"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Logo_1 = require("../Logo");

var Brandbar =
/** @class */
function (_super) {
  __extends(Brandbar, _super);

  function Brandbar(props) {
    var _this = _super.call(this, props) || this;

    _this.onResize = function (viewportSize) {
      _this.setState({
        viewport: viewportSize
      });
    };

    _this.state = {
      viewport: utils_1.WindowEvents.getViewportSize()
    };
    return _this;
  }

  Brandbar.prototype.componentDidMount = function () {
    utils_1.WindowEvents.addViewportCallback(this.onResize);
  };

  Brandbar.prototype.componentWillUnmount = function () {
    utils_1.WindowEvents.removeViewportCallback(this.onResize);
  };

  Brandbar.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        href = _a.href,
        id = _a.id,
        slogan = _a.slogan;
    var classNames = utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "footer-brandbar", className]);
    var brandbarProps = {
      className: classNames,
      id: id
    };
    return React.createElement("div", __assign({}, brandbarProps), React.createElement(Logo_1.Logo, {
      href: href,
      variant: Logo_1.Logo.Variants.MONOCHROME
    }), React.createElement("p", {
      className: CSSPrefix_1.lsgPre + "footer-brandbar-slogan"
    }, slogan));
  };

  return Brandbar;
}(React.Component);

exports.Brandbar = Brandbar;